import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-router-outlet',
	templateUrl:'./RouterOutletPluginCompPage.html',
	styles: [],
	styleUrls:['./RouterOutletPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class RouterOutletPluginCompPage
{
	mdContent_1098 = `\`\`\`java
import com.jwebmp.core.angular.components.RouterOutlet;
\`\`\``;
	mdContent_1099 = `\`\`\`java
new RouterOutlet()
\`\`\``;
}
